import { api } from "./client";
import type { ApiResponse } from "./types";

/** A photo or video on an event's wall (GET /events/{id}/media). */
export interface EventMediaItem {
  id: string;
  mediaType: string;
  url: string;
  thumbnailUrl: string | null;
  /** When the file says it was taken, on the venue's clock with its offset; null when it says nothing. */
  takenAt: string | null;
  /** in_app_camera, file_picker or unknown: the upload route's word. */
  captureSource: string;
  /** A video's length in whole seconds (at most 60); null for a photo. */
  durationSeconds: number | null;
  caption: string | null;
  /** accepted, or waiting for an organiser. */
  status: string;
  isHidden: boolean;
  /** Held by three members' reports until an organiser decides. */
  isHeld: boolean;
  isPicked: boolean;
  isMine: boolean;
  /** For its author and the organisers: accepted, waiting_for_time, waiting_for_host or held. Null otherwise. */
  review: string | null;
  author: { id: string; name: string; avatarUrl: string | null };
  createdAt: string;
}

/** `matches`: what the reader's matches who went added (signed in). */
export type EventMediaScope = "all" | "mine" | "picks" | "waiting" | "matches";

export function listEventMedia(eventId: string, scope: EventMediaScope = "all", cursor?: string) {
  return api.get<ApiResponse<{ items: EventMediaItem[]; nextCursor: string | null }>>(
    `/events/${eventId}/media`,
    { scope, cursor },
  );
}

/** File your own ready upload (category=event) under the event. */
export function addEventMedia(eventId: string, uploadId: string, caption?: string) {
  return api.post<ApiResponse<EventMediaItem>>(`/events/${eventId}/media`, { uploadId, caption });
}

/** Organisers: approve what waits, hide, pick. */
export function moderateEventMedia(
  eventId: string,
  mediaId: string,
  change: { hidden?: boolean; picked?: boolean; approved?: true; held?: false },
) {
  return api.patch<ApiResponse<EventMediaItem>>(`/events/${eventId}/media/${mediaId}`, change);
}

export function removeEventMedia(eventId: string, mediaId: string) {
  return api.delete<void>(`/events/${eventId}/media/${mediaId}`);
}
